import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navOptions } from "./webNavigationComponent";
import { GetPastTrips } from "../../context/trip/tripProvider";
import { GetCalculatorInfo } from "../../context/calculator/tour/calculatorProvider";
import { GetSitesAndActivityInfo } from "../../context/calculator/sitesAndActivity/sitesAndActivityProvider";

const BottomNavigationComponent = ({defaultIndex = 0}) => {
    const [value, setValue] = useState(defaultIndex);

    const navigate = useNavigate();
    
    const {clearActiveTour, clearEditTourHistory} = GetPastTrips();

    const tripInfo = GetCalculatorInfo();
    const siteAndActivityInfo = GetSitesAndActivityInfo();

    const selectPages = useCallback((newValue) => {
        setValue(newValue);
    
        if(defaultIndex === newValue) return;

        tripInfo?.clearCalculator();
        clearActiveTour();
        clearEditTourHistory();

        siteAndActivityInfo?.clearCalculator();
        siteAndActivityInfo?.clearEditSitesAndActivityHistory();
    
        navigate(navOptions[newValue].link);
    }, [tripInfo]);

    return (
        <>
            <Paper 
                sx={{ 
                    position: 'fixed', 
                    bottom: 0, 
                    left: 0, 
                    right: 0,
                    py: 1,
                    display: {xs: 'block', lg: 'none'}
                }} 
                elevation={3}
            >
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => selectPages(newValue)}
                >
                    {
                        navOptions.map((item, index) => {
                            return <BottomNavigationAction 
                                key={index}
                                label={item.label}
                                icon={item.icon}
                            />
                        })
                    }
                </BottomNavigation>
            </Paper>
        </>
    );
}

export default BottomNavigationComponent;